import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  iconButton2nzpucy7a6ixd as iconButton,
  get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth,
} from './view-utilities.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
} from '../../App.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  TextInput$_get_hint_$ref_uvwrja1fc638uz6ch32 as TextInput$_get_hint_$ref_uvwrja,
  TextInput$_set_hint_$ref_i30g2i16lyp5h9o9qbl as TextInput$_set_hint_$ref_i30g2i,
} from '../children/NewChildPlacementPage.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  TableSemantic_getInstance3cbunlgg7bvuu as TableSemantic_getInstance,
  TableRowSemantic_getInstance396gywh21vbqh as TableRowSemantic_getInstance,
} from '../../theme/semantics.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import { contains3hkd7li7hrfjb as contains } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { text189ciz0cnr32o as text } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { colOfExpensive3ig8osrmgzdfv as colOfExpensive } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function multiSelectAddButton(_this__u8e3s4, description, dialogTitle, selected, idOf, display, search, searchHint, emptyMessage) {
  var tmp;
  if (searchHint === VOID) {
    tmp = multiSelectAddButton$lambda;
  } else {
    tmp = searchHint;
  }
  searchHint = tmp;
  var tmp_0;
  if (emptyMessage === VOID) {
    tmp_0 = multiSelectAddButton$lambda_0;
  } else {
    tmp_0 = emptyMessage;
  }
  emptyMessage = tmp_0;
  var tmp_1 = Companion_getInstance().add_1;
  return iconButton(_this__u8e3s4, tmp_1, description, ($this$iconButton) => {
    onClick($this$iconButton, VOID, VOID, VOID, multiSelectAddButton$lambda$slambda($this$iconButton, dialogTitle, searchHint, emptyMessage, search, idOf, selected, display));
    return Unit_instance;
  });
}
function multiSelectAddButton$lambda(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementSearchHint_64804r_k$();
}
function multiSelectAddButton$lambda_0(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementNoOptionsFoundLabel_67d80d_k$();
}
function multiSelectAddButton$lambda$slambda$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementSearchIconDescription_uuv8wx_k$();
}
function multiSelectAddButton$lambda$slambda$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_placementDoneButton_4je2q8_k$();
}
function multiSelectAddButton$lambda$slambda$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function multiSelectAddButton$lambda$slambda($this_iconButton, $dialogTitle, $searchHint, $emptyMessage, $search, $idOf, $selected, $display) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var tmp = $this_iconButton.get_context_h02k06_k$();
    dialog(tmp, VOID, ($this$dialog, close) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (TextView())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      element.willAddChild_hz2iwc_k$(element_0);
      element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
      element_0.invoke_bnq13k_k$(getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0)), $dialogTitle);
      element_0.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_0);
      var query = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
      var queryDebounced = element.debounce_nclnee_k$(query, 300n);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      var this_1 = themed(element, FieldSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (RowOrCol())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      this_1.willAddChild_hz2iwc_k$(element_1);
      element_1.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
      var this_2 = get_centered(element_1);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (IconView())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_2.willAddChild_hz2iwc_k$(element_2);
      element_2.set_source_3o5lkf_k$(Companion_getInstance().search_1.resize_q1xpz0_k$(get_rem(1.25)));
      var tmp_1 = KMutableProperty0();
      var tmp_2 = IconView$_get_description_$ref_x7iif6(element_2);
      var tmp_3 = getPropertyCallableRef('description', 0, tmp_1, tmp_2, IconView$_set_description_$ref_rpvc1e(element_2));
      element_2.invoke_bnq13k_k$(tmp_3, multiSelectAddButton$lambda$slambda$lambda$lambda);
      element_2.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_2);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
      var this_3 = weight(element_1, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = new (TextInput())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      this_3.willAddChild_hz2iwc_k$(element_3);
      var tmp_4 = KMutableProperty0();
      var tmp_5 = TextInput$_get_hint_$ref_uvwrja(element_3);
      element_3.invoke_bnq13k_k$(getPropertyCallableRef('hint', 0, tmp_4, tmp_5, TextInput$_set_hint_$ref_i30g2i(element_3)), $searchHint);
      element_3.bind_gesskf_k$(element_3.content_1, query);
      element_3.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_3);
      element_1.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element_1);
      var filtered = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
        // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
        return $search($this$remember, queryDebounced);
      });
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_4 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_4);
      element.willAddChild_hz2iwc_k$(element_4);
      element_4.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      var tmp$ret$26 = weight(element_4, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_4 = get_scrolling(themed(sizeConstraints(tmp$ret$26, VOID, VOID, VOID, get_rem_0(20)), TableSemantic_getInstance()));
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_5 = new (RowOrCol())(this_4.get_context_h02k06_k$());
      ensureOutermostElement(element_5);
      this_4.willAddChild_hz2iwc_k$(element_5);
      element_5.set_vertical_nuap32_k$(true);
      var tmp_6 = get_centered(element_5);
      // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
      var this_5 = shownWhen(tmp_6, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(filtered).isEmpty_y1axqb_k$());
      // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_6 = themed(this_5, ForcePaddingSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_6 = new (TextView())(this_6.get_context_h02k06_k$());
      ensureOutermostElement(element_6);
      this_6.willAddChild_hz2iwc_k$(element_6);
      element_6.set_themeChoice_py59um_k$(element_6.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
      var tmp_7 = KMutableProperty0();
      var tmp_8 = TextView$_get_content_$ref_4pzcwl(element_6);
      element_6.invoke_bnq13k_k$(getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb(element_6)), $emptyMessage);
      element_6.onStartup_vrxh3i_k$();
      this_6.addChild_2qpft2_k$(element_6);
      colOfExpensive(element_5, filtered, false, VOID, ($this$colOfExpensive, item) => {
        var id = $idOf(item);
        // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
        var this_0 = themed($this$colOfExpensive, TableRowSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (ToggleButton())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        element.bind_gesskf_k$(element.checked_1, contains($selected, id));
        text(element, $display(item));
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
        return Unit_instance;
      });
      element_5.onStartup_vrxh3i_k$();
      this_4.addChild_2qpft2_k$(element_5);
      element_4.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_4);
      // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_7 = new (Separator())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_7);
      element.willAddChild_hz2iwc_k$(element_7);
      element_7.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_7);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_8 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_8);
      element.willAddChild_hz2iwc_k$(element_8);
      element_8.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      var this_7 = weight(element_8, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_9 = new (Space())(this_7.get_context_h02k06_k$());
      ensureOutermostElement(element_9);
      this_7.willAddChild_hz2iwc_k$(element_9);
      element_9.onStartup_vrxh3i_k$();
      this_7.addChild_2qpft2_k$(element_9);
      // Inline function 'com.lightningkite.kiteui.views.important' call
      // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
      var this_8 = themed(element_8, ImportantSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_9 = themed(this_8, ButtonSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_10 = new (Button())(this_9.get_context_h02k06_k$());
      ensureOutermostElement(element_10);
      this_9.willAddChild_hz2iwc_k$(element_10);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_11 = new (TextView())(element_10.get_context_h02k06_k$());
      ensureOutermostElement(element_11);
      element_10.willAddChild_hz2iwc_k$(element_11);
      var tmp_9 = KMutableProperty0();
      var tmp_10 = TextView$_get_content_$ref_4pzcwl(element_11);
      var tmp_11 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb(element_11));
      element_11.invoke_bnq13k_k$(tmp_11, multiSelectAddButton$lambda$slambda$lambda$lambda_0);
      element_11.onStartup_vrxh3i_k$();
      element_10.addChild_2qpft2_k$(element_11);
      onClick(element_10, VOID, VOID, VOID, multiSelectAddButton$lambda$slambda$lambda$slambda(close));
      element_10.onStartup_vrxh3i_k$();
      this_9.addChild_2qpft2_k$(element_10);
      element_8.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_8);
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    return Unit_instance;
  }), 0);
}
//region block: exports
export {
  multiSelectAddButton as multiSelectAddButton23vne58r85kkf,
};
//endregion

//# sourceMappingURL=multiSelectAddButton.mjs.map
